//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
//Types
import { ListingSpecialHoursData, LMspecialHours } from './types';
import { ActionGetLMSpecialHoursAPISuccess, ActionPostLMSpecialHoursAPISuccess } from './actions';
//Types

export interface EngineSpecialHourState {
  specialHoursData?: ListingSpecialHoursData;
}

const defaultState: EngineSpecialHourState = {
  specialHoursData: undefined
};

type GetLMSpecialHoursAction = ActionGetLMSpecialHoursAPISuccess | ActionPostLMSpecialHoursAPISuccess;

function specialHoursReducer(state: EngineSpecialHourState = defaultState, action: GetLMSpecialHoursAction): EngineSpecialHourState {
  switch (action.type) {
    case ACTIONS.GET_LMSPECIALHOURS_API_SUCCESS:
      {
        const {
          specialHoursData
        } = (action as ActionGetLMSpecialHoursAPISuccess).lmspecialHours
        return {
          ...state,
          specialHoursData: specialHoursData
        }
      }
    case ACTIONS.POST_LMSPECIALHOURS_API_SUCCESS:
      {
        const { specialHoursData } = (action as ActionPostLMSpecialHoursAPISuccess).lmspecialHours
        return {
          ...state,
          specialHoursData: specialHoursData ? { ...specialHoursData } : undefined
        }
      }
    default: {
      return {
        ...state
      }
    }
  }

}


export default specialHoursReducer